import { getUserLists, changeUserCurrentUrl, getUserEventHistory, getUserDataById, confirmIdentifire, createAdmin, forgotPassword, resetPassword, setLastPageVisited, updateUserDetails, updatUserRole } from '@/api/user'

const user = {
  state: {},
  mutations: {},
  actions: {
    getUserLists({ commit }, data) {
			return new Promise((resolve, reject) => {
				getUserLists(data).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

    changeUserCurrentUrl({ commit }, data) {
			return new Promise((resolve, reject) => {
				changeUserCurrentUrl(data).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

    GetUserEventHistory({ commit }, data) {
      return new Promise((resolve, reject) => {
        getUserEventHistory(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetUserDataById({ commit }, data) {
      return new Promise((resolve, reject) => {
        getUserDataById(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ConfirmIdentifire({ commit }, data) {
      return new Promise((resolve, reject) => {
        confirmIdentifire(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    CreateAdmin({ commit }, data) {
      return new Promise((resolve, reject) => {
        createAdmin(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ForgotPassword({ commit }, data) {
      return new Promise((resolve, reject) => {
        forgotPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ResetPassword({ commit }, data) {
      return new Promise((resolve, reject) => {
        resetPassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async SetLastPageVisited({ commit }, data) {
      return await setLastPageVisited(data);
    },

    updateUserDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateUserDetails(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    updatUserRole({ commit }, data) {
      return new Promise((resolve, reject) => {
        updatUserRole(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
	getters: {
		isRealAdmin: (state,getters) => {
			return getters.currentUser && getters.currentUser.user_role=='admin'
		},
		isAdmin: (state, getters) => {
			return getters.currentUser && (getters.currentUser.user_role == 'admin' || getters.currentUser.user_role == 'admin_observer')
		}
	}
}

export default user
